var $ = require('jquery');
var _ = require('lodash');

var submitForm = function (id, $form) {
  $.post('/custom_forms/' + id, $form.serialize())
    .then(function (data) {
      $form.text(data.message);
    })
    .fail(function (xhr) {
      if (xhr.status == 400) {
        // Invalid data
        var errors = xhr.responseJSON;
        $form
          .find('[data-id]').removeClass('error').end()
          .find('.error-message').show();

        _.each(errors, function (value, key) {
          $form.find('[data-id=id_' + key + ']').addClass('error');
        });
      } else {
        $form.text(xhr.responseJSON.message);
      }
    });
};

var loadCustomForm = function(i, el) {
  var $this = $(el),
      id = $this.data('id');

  $.get('/custom_forms/' + id, function (data) {
    var $form = $(data);
    $form
      .on('click', 'button.submit', function () { submitForm(id, $form) })
      .insertAfter($this);
  });
};

$(function () {
  $('.custom-form-placeholder').each(loadCustomForm);
});



//////////////////
// WEBPACK FOOTER
// ./common/js/custom_form.js
// module id = 10
// module chunks = 0